.mo-product-page {
  width: 100%;
  background: #F4F4F4;
  color: #9930E2;
  padding: 10px 7px;
  text-align: center;
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 440px;
  border: 1px solid #9930E2;
}
.skeleton-loader {
  width: 100%;
  height: 1em;
  background-color: #ddd;
  background-image: linear-gradient(90deg, #ddd, #ccc, #ddd);
  background-size: 200% 100%;
  background-repeat: no-repeat;
  border-radius: 1px;
  animation: loading 1.5s infinite;
  max-width: 245px;
  margin-right: auto;
  margin-bottom: 4px;
}

@keyframes loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
.mo-product-page p {
  font-family: 'Benton-Regular';
  text-align: left;
  font-size: 12px;
  line-height: 16px;
  margin: 0;
  margin-bottom: 4px;
  color: #073382;
}
.mo-product-page .mo-product-page__text{
  padding-right: 5px;
  width: 80%;
}
.mo-product-page .mo-product-page__text p:first-child{
  color: #9930E2;
  font-size: 14px;
  line-height: 18px;
  width: 100%;
    max-width: 245px;
}
.mo-product-page .mo-product-page__text-large{
  width: 100%;
  max-width: 276px !important;
}

.mobile {
  display: none;
}

.mo-product-page p b {
  font-family: 'Benton-Bold';
  font-weight: 300;
}
.mo-product-page p a{
  color: #9930e2;
  margin-left: 2px;
}
.mo-product-page__button {
  text-align: center;
}
.mo-product-page__image{
  width: 126px;
}
.mo-product-page__image svg{
  width: 100%;
}

@media (max-width: 528px) {
  .mo-product-page {
    max-width: 100%;
    width: inherit;
  }

  .mo-product-page .mo-product-page__text p:first-child{
    line-height: 16px;
  }

  .mobile {
    display: block;
  }
}